import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareNotificationsIssueLogsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-notifications-issue-logs',
	path: '/jira/software/projects/:projectKey/settings/notifications/issue-logs',
	exact: true,
};
